<div class="row">
  <div class="col-lg-12 col-sm-12 col-md-12 header-center">
    <table>
      <tr>
        <td>
          <img src="assets/images/PanadolLogo1x.png" class="header-logo" />
        </td>
        <td class="header-title">
          <strong>Efficacy of Paracetamol vs. Comparators</strong>
        </td>
      </tr>
    </table>
  </div>
</div>

<div class="row">
  <div class="col-lg-12">
    <div class="table-container" style="width:100%;visibility: hidden;">
      <table style="width:100%;table-layout:fixed">
        <tr>
          <td style="width: 62px;vertical-align: top;position: relative;left: 4px;">
            <div class="row scrollable" style="display: flex;">
              <div class="left-header">
                <div class="bg-blue row-1"></div>
                <div class="bg-blue row-2" style="height:135px;">Placebo</div>
                <div class="bg-blue row-3" style="height:82px;">Ibuprofen</div>
                <div class="bg-blue row-4" style="height:80px;">Aspirin</div>
                <div class="bg-blue row-5" style="height:80px;">Naproxen</div>
                <div class="bg-blue row-6" style="height:55px;">Celecoxib</div>
              </div>
            </div>
          </td>
          <td style="vertical-align:top;">
            <!-- scrollable right side content -->
            <div class="right-side" style="width:100%;">
              <div class="top-header" style="table-layout:fixed;width:100%">
                <div class="row scrollable" style="display: flex;">
                  <div id="parent-div-2" class="column">
                    <div class="row-1">Fever</div>
                    <div class="bg-green table-text-color row-2">
                      <img src="assets/images/plus.png" class="table-icon" /><br />
                      <a (click)="open(Ghosh)"><strong>Ghosh, 2013;</strong></a> <br />
                      (Non-inferiority <br />
                      trial Vs <br />
                      Paracetamol<br />
                      1000mg SR <br />
                      formulation)<br />
                      <a (click)="open(Bachert)"><strong>Bachert, 2005;</strong></a>
                    </div>
                    <div class="row-3 bg-yellow table-text-color"> <img src="assets/images/equal.png"
                        class="table-icon" /><br />
                      (As per NICE<br />
                      2018 guidelines) <br />

                    </div>
                    <div class="row-4 bg-yellow table-text-color">
                      <img src="assets/images/equal.png" class="table-icon" /><br />
                      <a (click)="open(Bachert)"><strong>Bachert, 2005</strong></a><br />

                    </div>
                    <div class="row-5 empty-div table-text-color">&nbsp;</div>
                    <div class="row-6 empty-div table-text-color">&nbsp;</div>
                  </div>
                  <div id="parent-div-3" class="column">
                    <div class="row-1">Headache</div>
                    <div class="bg-green table-text-color row-2">
                      <img src="assets/images/plus.png" class="table-icon" /><br />
                      <strong>
                        <a (click)="open(Peters)">Peters, 1983;</a><br />
                        <a (click)="open(Migliardi)">Migliardi, 1994;</a>
                      </strong>
                    </div>
                    <div class="row-3 bg-yellow table-text-color"> <img src="assets/images/equal.png"
                        class="table-icon" /><br />
                      <a (click)="open(Moore)"><strong>Moore RA, 2014</strong></a><br />
                    </div>
                    <div class="row-4 bg-yellow table-text-color">
                      <img src="assets/images/equal.png" class="table-icon" /><br />
                      <a (click)="open(Peters)"><strong>Peters, 1983</strong></a><br />
                    </div>
                    <div class="row-5 bg-yellow table-text-color">
                      <img src="assets/images/equal.png" class="table-icon" /><br />
                      <a (click)="open(Prior)"><strong>Prior, 2002</strong></a><br /></div>

                    <div class="row-6 empty-div table-text-color">&nbsp;</div>
                  </div>
                  <div id="parent-div-4" class="column">
                    <div class="row-1">Migraine</div>
                    <div class="bg-green table-text-color row-2">
                      <img src="assets/images/plus.png" class="table-icon" /><br />
                      <strong>
                        <a (click)="open(Derry)">Derry, 2013;</a> <br />
                        <a (click)="open(Prior2020)">Prior, 2010;</a> <br />
                        <a (click)="open(Lipton)">Lipton, 2000;</a> <br />
                      </strong>
                    </div>
                    <div class="row-3 empty-div table-text-color">&nbsp;</div>
                    <div class="row-4 empty-div table-text-color">&nbsp;</div>
                    <div class="row-5 empty-div table-text-color">&nbsp;</div>
                    <div class="row-6 empty-div table-text-color">&nbsp;</div>
                  </div>
                  <div id="parent-div-5" class="column">
                    <div class="row-1">Period pain</div>
                    <div class="bg-green table-text-color row-2">
                      <img src="assets/images/plus.png" class="table-icon" /><br />
                      <strong>
                        <a (click)="open(Ali)">Ali, 2007;</a> <br />
                        <a (click)="open(Ali)">A2370237;</a> <br /><br />
                        <a (click)="open(Milsom)">Milsom, 2002;</a> <br />
                      </strong>
                    </div>
                    <div class="row-3 empty-div table-text-color">&nbsp;</div>
                    <div class="row-4 empty-div table-text-color">&nbsp;</div>
                    <div class="row-5 bg-pink table-text-color">
                      <img src="assets/images/minus.png" class="table-icon" /><br />
                      <a (click)="open(Milsom)"><strong>Milsom, 2002</strong></a><br />
                    </div>
                    <div class="row-6 empty-div table-text-color">&nbsp;</div>

                  </div>
                  <div id="parent-div-6" class="column">
                    <div class="row-1">Body pain,<br /> Musculoskeletal<br /> pain<br /> (Strains/Sprains)</div>
                    <div class="bg-green table-text-color row-2">
                      <img src="assets/images/plus.png" class="table-icon" /><br />
                      <strong>
                        <a (click)="open(Wade)">Wade, 1982;</a> <br />
                        <a (click)="open(Wade)">Hong, 2017;</a> <br />
                      </strong>
                    </div>
                    <div class="row-3 bg-yellow table-text-color">
                      <img src="assets/images/equal.png" class="table-icon" /><br />
                      <a (click)="open(Wade)"><strong>Jones, 2015</strong></a><br />
                    </div>
                    <div class="row-4 empty-div table-text-color">&nbsp;</div>
                    <div class="row-5 empty-div table-text-color">&nbsp;</div>
                    <div class="row-6 empty-div table-text-color">&nbsp;</div>

                  </div>
                  <div id="parent-div-7" class="column">
                    <div class="row-1">Joint pain/<br /> osteoarthritis</div>
                    <div class="bg-green table-text-color row-2">
                      <img src="assets/images/plus.png" class="table-icon" /><br />
                      <strong>
                        <a (click)="open(Towheed)">Towheed, 2006;</a><br />
                        <a (click)="open(Towheed)">Neame, 2004;</a> <br />
                        <a (click)="open(Towheed)"> Zhang, 2004;</a> <br /><br />
                        Panadol Osteo Vs<br />
                        standard Panadol<br />
                        <a (click)="open(Bacon)">Bacon, 2002;</a><br />
                        <a (click)="open(Benson)">Benson, 2009;</a>
                      </strong>
                    </div>
                    <div class="row-3 bg-yellow table-text-color"> <img src="assets/images/equal.png"
                        class="table-icon" /><br />
                      <a (click)="open(Bradley)"><strong>Bradley, 1991</strong></a><br />
                    </div>

                    <div class="row-4 empty-div table-text-color">&nbsp;</div>
                    <div class="row-5 empty-div table-text-color">&nbsp;</div>
                    <div class="row-6 bg-yellow table-text-color">
                      <img src="assets/images/equal.png" class="table-icon" /><br />
                      Panadol Osteo:<br />
                      <a (click)="open(Yelland)"><strong>Yelland, 2007</strong></a><br />
                    </div>
                  </div>
                  <div id="parent-div-8" class="column">
                    <div class="row-1">Dentalpain/<br /> post dental<br /> procedure/<br /> tooth extraction</div>
                    <div class="bg-green table-text-color row-2">
                      <img src="assets/images/plus.png" class="table-icon" /><br />
                      GSK STUDY<br />
                      <strong>
                        <a (click)="open(A1030174)">A1030174;</a> <br />
                        <a (click)="open(A1030231)">A1030231;</a> <br /><br />
                        <a (click)="open(A1030231)">Grattan, 2004;</a><br />
                      </strong>
                    </div>
                    <div class="row-3 bg-yellow table-text-color"> <img src="assets/images/equal.png"
                        class="table-icon" /><br />
                      <a (click)="open(A1030231)"><strong>Deshpande, 2014</strong></a>
                    </div>
                    <div class="row-4 empty-div table-text-color">&nbsp;</div>
                    <div class="row-5 empty-div table-text-color">&nbsp;</div>
                    <div class="row-6 empty-div table-text-color">&nbsp;</div>

                  </div>
                  <div id="parent-div-9" class="column">
                    <div class="row-1">Sore throat<br /> pain</div>
                    <div class="bg-green table-text-color row-2">
                      <img src="assets/images/plus.png" class="table-icon" /><br />
                      <strong><a (click)="open(Burnett)">Burnett, 2006</a><br /></strong>
                      (Panadol Actifast) <br />
                    </div>
                    <div class="row-3 bg-yellow table-text-color"> <img src="assets/images/equal.png"
                        class="table-icon" /><br />
                      (NICE 2018<br />
                      guidelines)<br />
                      ESCMID (Pelucchi, <br />
                      2012).
                    </div>
                    <div class="row-4 empty-div table-text-color">&nbsp;</div>
                    <div class="row-5 empty-div table-text-color">&nbsp;</div>
                    <div class="row-6 empty-div table-text-color">&nbsp;</div>
                  </div>
                  <div id="parent-div-10" class="column">
                    <div class="row-1">Post vaccination/<br /> Covid vaccination<br /> pain and fever</div>
                    <div class="bg-green table-text-color row-2">
                      <img src="assets/images/plus.png" class="table-icon" /><br />
                      <strong><a (click)="open(Aoki)">Aoki, 1993</a><br /></strong>
                      (Suitability study) <br />

                    </div>
                    <div class="row-3 empty-div table-text-color">&nbsp;</div>
                    <div class="row-4 empty-div table-text-color">&nbsp;</div>
                    <div class="row-5 empty-div table-text-color">&nbsp;</div>
                    <div class="row-6 empty-div table-text-color">&nbsp;</div>
                  </div>
                  <div id="parent-div-11" class="column">
                    <div class="row-1">Fever due to<br /> dengue/malaria/<br /> chikungunya/<br /> Zika</div>
                    <div class="bg-green table-text-color row-2">
                      <img src="assets/images/plus.png" class="table-icon" /><br />
                      (recommended by<br />
                      various guidelines)<br />
                    </div>
                    <div class="row-3 bg-grey center-align table-text-color">
                      Should be avoided<br />
                      to reduce the risk<br />
                      of increased <br />
                      bleeding<br />
                    </div>
                    <div class="row-4 bg-grey center-align table-text-color">
                      Should be avoided<br />
                      to reduce the risk<br />
                      of increased <br />
                      bleeding
                    </div>
                    <div class="row-5 bg-grey center-align table-text-color">
                      Should be avoided<br />
                      to reduce the risk<br />
                      of increased <br />
                      bleeding<br /><br />
                    </div>
                    <div class="row-6 bg-grey center-align table-text-color">
                      Not indicated<br />
                    </div>
                  </div>
                  <div id="parent-div-12" class="column">
                    <div class="row-1">COVID<br /> associated<br /> fever<br /> and pain</div>
                    <div class="bg-green table-text-color row-2">
                      <img src="assets/images/plus.png" class="table-icon" /><br />
                      Recommended<br />
                      by PAHO, <br />
                      ACIN and EMA
                    </div>
                    <div class="row-3 empty-div table-text-color">&nbsp;</div>
                    <div class="row-4 empty-div table-text-color">&nbsp;</div>
                    <div class="row-5 empty-div table-text-color">&nbsp;</div>
                    <div class="row-6 empty-div table-text-color">&nbsp;</div>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>


<div class="row" style="margin-top:5px;">
  <div class="col-lg-12" style="font-family:OpenSansRegular;font-size:9px;color:#124982;">
    <strong>Panadol Advance:</strong> The formulation with the patented Optizorb technology in Panadol Advance speeds up
    the rate at which the paracetamol tablet disintegrates and dissolves in the stomach
    resulting in faster absorption. The studies comparing Panadol Advance versus Panadol standard confirm the benefits
    of the formulation. (GSK Data on File. Study <strong><a (click)="open(A1900385)">A1900385</a>;
      <a (click)="open(A1900260)">A1900260</a>;
      <a (click)="open(A4000684)">A4000684</a>;
      <a (click)="open(A1900260)">Wilson 2011</a>;
      <a (click)="open(wilson)">A03001V96</a>;
      <a (click)="open(Yue)">Yue 2013</a>)</strong>.
  </div>
  <div class="col-lg-12" style="font-family:OpenSansRegular;font-size:9px;color:#124982;">
    <strong>Panadol Actifast</strong> speeds up the rate at which the paracetamol tablet disintegrates and dissolves in
    the stomach resulting in faster absorption.
    Panadol Actifast vs. Panadol Standard: GSK Study <strong><a (click)="open(A1030174)">A1030174</a>;
      <a (click)="open(Moller)"> Moller 2000</a></strong>.<br />
    Panadol Advance is the only SKU for symptoms of pain and fever in COVID and post COVID vaccination.
    Paracetamol is preferred in fever with dengue, malaria, chikungunya and Zika due to superior suitability.
  </div>
  <div class="col-lg-12" style="font-family:OpenSansRegular;font-size:9px;color:#124982;">
    * NSAIDs - Non-steroidal anti-inflammatory drugs.
    **ESCMID - European Society for Clinical Microbiology and Infectious Diseases.
  </div>
</div>
<div class="row" style="margin-top:10px;">
  <div class="col-lg-7" style="font-family:OpenSansRegular;font-size:9px;color:#124982;">
    <b>Instructions:</b><br />
    Click on the study number or the author name to see the study details and summary.
  </div>
  <div class="col-lg-5">
    <div style="float: right;">
      <div class="legend-icon bg-green" (click)="active = 1" (mouseover)="active = 1" (mouseout)="active = 0">
        <div class="call-out-box" *ngIf="active == 1">
          <img class="popup-panadol-green" />
        </div>
      </div>
      <div class="legend-icon bg-yellow" (click)="active = 2" (mouseover)="active = 2" (mouseout)="active = 0">
        <div class="call-out-box" *ngIf="active == 2">
          <img class="popup-panadol-yellow" />
        </div>
      </div>
      <div class="legend-icon bg-pink" (click)="active = 3" (mouseover)="active = 3" (mouseout)="active = 0">
        <div class="call-out-box" *ngIf="active == 3">
          <img class="popup-panadol-pink" />
        </div>
      </div>
      <div class="legend-icon bg-grey" (click)="active = 4" (mouseover)="active = 4" (mouseout)="active = 0">
        <div class="call-out-box" *ngIf="active == 4">
          <img class="popup-panadol-grey" />
        </div>
      </div>
    </div>

  </div>
</div>

<ng-template #Ghosh let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        Panadol provides <strong>
          effective
          relief from
          pain and fever
        </strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>

  <div class="modal-body pad-t-b-modal">
    <div class="container">
      <div class="row" style="padding-top: 10px;">
        <div class="col-lg-6 col-x1-3 col-sm-12">
          <table>
            <tr>
              <td style="vertical-align: top;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px; vertical-align: top;">
                  1.&nbsp;
                </p>
              </td>
              <td>
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 5px;">
                  Open label, multicenter, randomized, non-inferiority trial,
                  patients (n=247) receiving paracetamol 500 mg
                  every 6 hrs (2 g/d) for 3 consecutive days
                </p>
              </td>
            </tr>

            <tr>
              <td style="vertical-align: top;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px; vertical-align: top;">
                  2.&nbsp;
                </p>
              </td>
              <td>
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 5px;">
                  The overall mean reduction in pain from the baseline to
                  end of treatment was 76.95%
                </p>
              </td>
            </tr>

            <tr>
              <td style="vertical-align: top;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px; vertical-align: top;">
                  3.&nbsp;
                </p>
              </td>
              <td>
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 5px;">
                  The daily mean VAS scores were (Day 0 = 5.0852; <br />
                  Day 1 = 3.3163; Day 2 = 1.831); demonstrating efficacy
                  from the first recorded measurement post dosing.
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px; vertical-align: top;">
                  4.&nbsp;
                </p>
              </td>
              <td>
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 5px;">
                  The overall mean reduction in body temperature from
                  baseline to end of day 3 treatment was 2.48%
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px; vertical-align: top;">
                  5.&nbsp;
                </p>
              </td>
              <td>
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 5px;">
                  The daily reduction in mean temperature was ~1° F
                  (day 0 = 100.07° F; Day 1 = 99.045°; Day 2 = 98.843° F).
                </p>
              </td>
            </tr>
          </table>
        </div>
        <div class="col-lg-6 col-x1-7 col-sm-12">
          <table>
            <tr>
              <td>
                <img class="img-fluid popone" src="assets/images/panadol/popOne.svg">
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      VAS= visual analog scale<br />
      Ghosh S, Patel J, Patel H, Pandya N, Naik S, Patel H. Pain <i>Med</i>. 2013 Mar;14(3):436-41
    </p>
  </div>
</ng-template>


<ng-template #Bachert let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        <strong>
          Panadol vs. aspirin
        </strong>in fever
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div class="container" style="padding-left: 0px;">
      <div class="row">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12">
          <table>
            <tr>
              <td>
                <p style="font-family: OpenSansRegular;font-size: 18px;color: #124982;line-height: 18px;">
                  <strong>Panadol has comparable efficacy to aspirin in the treatment of URTIs and fever</strong>
                </p>
              </td>
            </tr>
          </table>
        </div>
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12 pad-l-55">
          <table>
            <tr>
              <td>
                <div class="row" style="text-align: center;">
                  <div class="col-lg-5 col-md-5 col-sm-12 no-padding">
                    <img class="img-fluid" src="assets/images/panadol/pop3ax.svg" style="width: 364px;">
                  </div>
                  <div class="col-lg-7 col-md-7 col-sm-12 no-padding">
                    <img class="img-fluid" src="assets/images/panadol/pop3aax.svg" style="width: 374px;">
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div class="col-lg-6 col-md-7 colxl-7 col-sm-12" style="padding-top: 20px;">
          <table>
            <tr>
              <td>
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 18px;margin: 0rem;">
                  <strong>Efficacy:</strong>
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tr>
                    <td style="vertical-align: top;">
                      <p
                        style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin: 0rem;">
                        •&nbsp;
                      </p>
                    </td>
                    <td>
                      <p
                        style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin: 0rem;">
                        A randomised, double-blind, double-dummy, placebo-controlled,
                        parallel-group multicenter study in patients with upper respiratory
                        tract infection and fever (N=392)
                      </p>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tr>
                    <td style="vertical-align: top;">
                      <p
                        style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin: 0rem;">
                        •&nbsp;
                      </p>
                    </td>
                    <td>
                      <p
                        style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin: 0rem;">
                        No significant differences were seen between Panadol and aspirin
                        in the area under the curve (AUC) for the change in body
                        temperature from baseline to 4 hours after dosing
                      </p>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tr>
                    <td style="vertical-align: top;">
                      <p
                        style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin: 0rem;">
                        •&nbsp;
                      </p>
                    </td>
                    <td>
                      <p
                        style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin: 0rem;">
                        Significant reductions were seen in mean intensity of headache,
                        aching, and fever discomfort with both Panadol and aspirin
                        at most time points (P&#60;0.001) </p>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
        <div class="col-lg-6 col-md-5 colxl-5 col-sm-12" style="padding-top: 20px;">
          <table>
            <tr>
              <td>
                <p style="font-family: OpenSansRegular;font-size: 14px;color: #124982;line-height: 18px;margin: 0rem;">
                  <strong>Safety:</strong>
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tr>
                    <td style="vertical-align: top;">
                      <p
                        style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin: 0rem;">
                        •&nbsp;
                      </p>
                    </td>
                    <td>
                      <p
                        style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin: 0rem;">
                        Panadol and aspirin were equally well tolerated
                      </p>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tr>
                    <td style="vertical-align: top;">
                      <p
                        style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin: 0rem;">
                        •&nbsp;
                      </p>
                    </td>
                    <td>
                      <p
                        style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin: 0rem;">
                        All adverse events were mild or moderate in intensity
                      </p>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table>
                  <tr>
                    <td style="vertical-align: top;">
                      <p
                        style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin: 0rem;">
                        •&nbsp;
                      </p>
                    </td>
                    <td>
                      <p
                        style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin: 0rem;">
                        No serious or severe adverse events were reported</p>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      Bachert C <i>et al</i>. Clin Ther 2005;27:993-1003.
    </p>
  </div>
</ng-template>

<ng-template #Peters let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        <strong>
          Panadol provides significant pain relief in periodic,
          moderately severe headache/tension headache
        </strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div class="container" style="padding-left: 0px;">
      <div class="row">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12">
          <table>
            <tr>
              <td>
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  Randomized, parallel, double-blind study
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top; padding-top: -2px;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  269 otherwise healthy persons experiencing periodic, moderately severe headache of a type that had
                  previously
                  responded to nonprescription medications
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top; padding-top: -2px;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  Intervention: 1,000 mg acetaminophen, 650 mg aspirin, or an identical placebo, for headache.
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top; padding-top: -2px;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  Headache intensity and relief scores over the following six hours were obtained and assessed by sums
                  of pain
                  intensity difference and values of pain relief scores analyses.
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top; padding-top: -2px;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  Responses for the group, and for the subgroup with tension headaches (107 persons) showed no
                  differences
                  between the effects of the active medications.
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top; padding-top: -2px;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  The effects of each medication were strongly superior to placebo.
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top; padding-top: -2px;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  There were no differences in side effects among the three treatment modalities.
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top; padding-top: -2px;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  Acetaminophen (1,000 mg) and aspirin (650 mg) are clinically similar in treating the headaches for
                  which they
                  are commonly taken
                </p>
              </td>
            </tr>
          </table>
          <table style="height: 30px;"></table>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      Peters BH, Fraim CJ, Masel BE. Am J Med 1983; 74: 36-42.
    </p>
  </div>
</ng-template>

<ng-template #Moore let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        <strong>
          Panadol vs. Ibuprofen
        </strong>in tension type headache
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div class="container" style="padding-left: 0px;">
      <div class="row">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12">
          <table>
            <tr>
              <td>
                <p style="font-family: OpenSansRegular;font-size: 14px;color: #124982;line-height: 15px;">
                  <strong>Efficacy of Panadol and ibuprofen in tension-type headache does not differ</strong>
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                  Indirect comparison of data from randomised studies of Panadol 1000 mg and
                  Ibuprofen 400 mg
                </p>
              </td>
            </tr>
          </table>
          <!-- <table>
            <tr>
              <td style="vertical-align: top;">

              </td>
              <td class="container-fluid" style="text-align:center;">
                <p style="font-family: OpenSansRegular;font-size: 14px;color: #124982;line-height: 14px;">
                  Drugs with dose in milligrams. Size of study arm is proportional to the size of the symbol (inset
                  scale).
                </p>
              </td>
            </tr>
          </table> -->
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12" style="display: flex;justify-content: center;">
          <table>
            <tr>
              <td>
                <img class="img-fluid pop2ax" src="assets/images/panadol/pop2ax2x.png" />
              </td>
            </tr>
          </table>
        </div>
        <div style="display: flex;justify-content: center;">
          <table>
            <tr>
              <td>
                <p style="font-family: OpenSansRegular;font-size: 9px;color:black;line-height: 13px;margin-top: 5px;margin-bottom: 0px;">
                  <strong>
                    Drugs with dose in milligrams. Size of study arm is proportional to the size of the symbol (inset
                    scale).
                  </strong>
                </p>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      Moore RA <i>et al</i>. Pain 2014;155:2220-2228
    </p>
  </div>
</ng-template>


<ng-template #Migliardi let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        Panadol Extra effective<strong>
          in tension type headache
        </strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div class="container" style="padding-left: 0px;">
      <div class="row">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12">
          <table>
            <tr>
              <td style="vertical-align: top;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  Six randomized, double-blind, two-period crossover studies, conducted under similar protocols,
                  compared the
                  efficacy of two analgesic combinations containing caffeine with an acetaminophen 1000 mg control and
                  with a
                  placebo in outpatients with episodic tension-type headaches.
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  In four studies, comprising 1900 patients, the caffeine-containing analgesic consisted of a
                  combination
                  of 500 mg
                  acetaminophen, 500 mg aspirin, and 130 mg caffeine (APAP/ASA/CAF).
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top; padding-top: -2px;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  In two studies, comprising 911 patients, the caffeine-containing analgesic consisted of a combination
                  of 1000 mg
                  acetaminophen and 130 mg caffeine (APAP/CAF).
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top; padding-top: -2px;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  Patients self-medicated for moderate or severe headache pain, and with a self-rating record they rated
                  their pain
                  and its relief hourly for 4 hours.
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top; padding-top: -2px;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  <strong>In all six studies, the caffeine-containing analgesics were significantly superior both to
                    placebo and to 1000 mg
                    acetaminophen, and acetaminophen was significantly superior to placebo.</strong>
                </p>
              </td>
            </tr>
          </table>
          <table style="height: 100px;"></table>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      Migliardi JR et al. Caffeine as an analgesic adjuvant in tension headache. Clin Pharmacol Ther 1994; 56:576-586.
    </p>
  </div>
</ng-template>


<ng-template #Prior let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        Panadol as effective as naproxen to
        <strong>
          relieve pain of <br />tension-type headache (TTH)
        </strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>
  <div class="modal-body tthmodal">
    <div class="container" style="padding-left: 0px;">
      <div class="row">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12">
          <table>
            <tr>
              <td>
                <p style="font-family: OpenSansRegular;font-size: 18px;color: #124982;line-height: 21px;">
                  <strong>In a randomized, double-blind, placebo-controlled trial of 1000 mg Paracetamol
                    and 375 mg naproxen in patients with TTH, both Paracetamol and naproxen were
                    significantly better than placebo on:</strong>
                </p>
              </td>
            </tr>
          </table>
          <table>
            <tr>
              <td>
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 5px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 5px;">
                  Sum of pain intensity differences from baseline (SPID)
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top; padding-top: -2px;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 5px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 5px;">
                  Maximum pain intensity difference from baseline occurring over the observation period (MAXPID)
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top; padding-top: -2px;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 5px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 5px;">
                  Time- interval weighted sum of the pain relief scores (TOTPAR) and
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top; padding-top: -2px;">
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 5px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 5px;">
                  Maximum pain relief that occurred during the observation period (MAXPAR) (p=0.029)
                  and (p=0.009) respectively, but not different from each other (p=0.498).
                </p>
              </td>
            </tr>
          </table>
          <table style="height: 15px;"></table>

        </div>
        <div class="col-lg-12 col-md-12 col-xl-12 col-sm-12">
          <table style="border: 1px solid #00A0DF;">
            <tr>
              <td style="vertical-align: top; padding: 15px 15px 0px 15px;">

                <p style="font-family: OpenSansRegular;font-size: 12px;color: #00A0DF;line-height: 16px;">
                  A significantly larger mean pain intensity difference from baseline was observed
                  for acetaminophen 1000 mg (1.13) than for naproxen 375 mg (0.95) (P=0.036)
                  at one hour after treatment.
                </p>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      Prior MJ et al. Cephalgia 2002; 22: 740-748.
    </p>
  </div>
</ng-template>

<ng-template #Derry let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        Panadol for <strong>acute migraine headaches</strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>
  <div class="modal-body" style="padding-top: 8px;">
    <div class="container" style="padding-left: 0px;">
      <div class="row">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12">
          <table>
            <tr>
              <td>
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 0px;">
                  Eleven studies (2942 participants, 5109 attacks) compared paracetamol (APAP) 1000 mg, alone or
                  in<br />
                  combinations with an antiemetic, with placebo (PBO) or other active comparators (mainly sumatriptan
                  100 mg).
                </p>
              </td>
            </tr>
          </table>
          <table style="height: 15px;"></table>
          <table>
            <tr>
              <td>
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #00A0DF;line-height: 16px;margin-bottom: 10px;">
                  <strong>For all efficacy outcomes APAP was superior to placebo</strong>
                </p>
              </td>
            </tr>
          </table>
          <table>
            <tr>
              <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">

                •&nbsp;

              </td>
              <td
                style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;padding-bottom: 5px;">

                2-hr pain–free (19% for APAP vs 10% with placebo)

              </td>
            </tr>
            <tr>
              <td
                style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">

                •&nbsp;

              </td>
              <td
                style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;padding-bottom: 5px;">

                2-hr pain relief (56% APAP vs. 36% with PBO) and 1-hr headache relief (39% APAP vs 20% with PBO,
                when medications were taken for moderate to severe pain.

              </td>
            </tr>
            <tr>
              <td
                style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">

                •&nbsp;

              </td>
              <td
                style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;padding-bottom: 5px;">

                APAP 1000 mg alone is statistically superior to PBO in the treatment of acute migraine.

              </td>
            </tr>

          </table>
          <table style="height: 30px;"></table>

        </div>

      </div>
    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      Derry S, Moore RA. Cochrane Database of Systematic Reviews 2013, Issue 4. Art. No.: CD008040. DOI:
      10.1002/14651858.CD008040.pub3.
    </p>
  </div>
</ng-template>

<ng-template #Prior2020 let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        Panadol effective and well-tolerated treatment for
        <strong>
          episodic and moderate migraine headache
        </strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>
  <div class="modal-body modalfive">
    <div class="container" style="padding-left: 0px;">
      <div class="row">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12">

          <table style="height: 10px;"></table>
          <table>
            <tr>
              <td style="vertical-align: top;font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                •&nbsp;
              </td>
              <td
                style="vertical-align: top;font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;padding-bottom: 5px;">
                Randomized, placebo-controlled, double-blind clinical trial of 6 hours duration.
              </td>
            </tr>
            <tr>
              <td
                style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                •&nbsp;
              </td>
              <td
                style="vertical-align: top;font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;padding-bottom: 5px;">
                346 outpatient adults 18-72 years of age with migraine headache of moderate to severe intensity
              </td>
            </tr>
            <tr>
              <td
                style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                •&nbsp;
              </td>
              <td
                style="vertical-align: top;font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;padding-bottom: 5px;">
                Each patient was randomly assigned to a single dose of study medication of acetaminophen 1000 mg (n =
                177) or placebo (n = 169).
              </td>
            </tr>

            <tr>
              <td
                style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                •&nbsp;
              </td>
              <td
                style="vertical-align: top;font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;padding-bottom: 5px;">
                <strong>Primary efficacy measure:</strong> The percentage of patients with a reduction in baseline
                headache pain intensity from severe or moderate to
                mild or none 2 hours after treatment and the headache pain intensity difference from baseline at 2 hours
              </td>
            </tr>
            <tr>
              <td
                style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                •&nbsp;
              </td>
              <td
                style="vertical-align: top;font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;padding-bottom: 5px;">
                <strong>Other measures:</strong> pain relief, severity differences from baseline for migraine-associated
                symptoms of nausea, photophobia, phonophobia,
                and functional disability, and percentage of patients with migraine-associated symptoms reduced to none
              </td>
            </tr>
          </table>
          <table style="height: 15px;"></table>
          <table style="border: 1px solid #124982;">
            <tr>
              <td style="padding: 10px;">
                <table>
                  <tr>
                    <td
                      style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                      •&nbsp;
                    </td>
                    <td
                      style="vertical-align: top;font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;padding-bottom: 5px;">
                      Significantly (P = .001) more patients treated with acetaminophen 1000 mg reported mild to no pain
                      after 2 hours (52.0%)
                      compared with those treated with placebo (32.0%).
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                      •&nbsp;
                    </td>
                    <td
                      style="vertical-align: top;font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;padding-bottom: 5px;">
                      The mean pain intensity difference from baseline measured at 2 hours was significantly (P < .001)
                        greater for patients treated with acetaminophen 1000 mg (0.82) compared with those treated with
                        placebo (0.46). </td> </tr> <tr>
                    <td
                      style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                      •&nbsp;
                    </td>
                    <td
                      style="vertical-align: top;font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;padding-bottom: 5px;">
                      A significant difference in favor of acetaminophen 1000 mg over placebo was also observed at 1
                      hour after treatment for
                      the percentage of patients with mild to no pain and for mean pain intensity difference from
                      baseline.
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                      •&nbsp;
                    </td>
                    <td
                      style="vertical-align: top;font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;padding-bottom: 5px;">
                      Acetaminophen 1000 mg was significantly more effective than placebo for all but 1 (pain reduced to
                      none at 2 hours)
                      clinically important secondary pain relief outcomes.
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                      •&nbsp;
                    </td>
                    <td
                      style="vertical-align: top;font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15p16pxx;padding-bottom: 5px;">
                      Mean severity changes from baseline in migraine-associated symptoms of nausea, photophobia,
                      phonophobia, and functional
                      disability at 2 and 6 hours were significantly (P < .001) in favor of acetaminophen over placebo;
                        the percentage of patients with no symptoms at 2 and 6 hours statistically significantly favored
                        acetaminophen in 6 of 8 comparisons. </td> </tr> <tr>
                    <td
                      style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                      •&nbsp;
                    </td>
                    <td style="vertical-align: top;font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                      Adverse events, overall, and specifically for nausea, were reported more frequently in the placebo
                      group.
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>

        </div>

      </div>
    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      Prior MJ, Codispoti JR, Fu M. Headache: The Journal of Head and Face Pain. 2010 May 1;50(5):819-33.
    </p>
  </div>
</ng-template>

<ng-template #Lipton let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        Panadol–highly effective for <strong>treating migraine pain</strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>
  <div class="modal-body" style="padding-top: 0px;">
    <div class="container" style="padding-left: 0px;">
      <div class="row">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12">

          <table style="height: 10px;"></table>
          <table>
            <tr>
              <td
                style="vertical-align: top;font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                •&nbsp;
              </td>
              <td
                style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;padding-bottom: 6px;">
                Randomized, double-blind, placebo-controlled study comparing oral acetaminophen, 1000 mg with
                identical placebo in the treatment of a single acute migraine attack
              </td>
            </tr>
            <tr>
              <td
                style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                •&nbsp;
              </td>
              <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                Main Outcome measures: The percentage of subjects who, at 2 hours after dosing, experienced a change in
                baseline pain intensity from severe or moderate pain to mild or no pain (headache response); and pain
                intensity
                difference from baseline at the 2-hour post medication assessment.
              </td>
            </tr>
          </table>
          <table style="height: 20px;"></table>
        </div>
        <div class="col-lg-6 col-xl-6 col-md-6 col-sm-12">
          <table>
            <tr>
              <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                <strong>Results</strong>
              </td>
            </tr>
            <tr>
              <td>
                <img class="img-fluid" src="assets/images/panadol/Benson2.png">

              </td>
            </tr>
          </table>
        </div>
        <div class="col-lg-6 col-xl-6 col-md-6 col-sm-12">
          <table style="height: 16px;"></table>
          <table>
            <tr>
              <td
                style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                1.&nbsp;
              </td>
              <td
                style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;padding-bottom: 6px;">
                The mean pain intensity difference from baseline 2 hours after
                dosing was 1.08 in the acetaminophen group and 0.73 in the
                placebo group (P&lt;.001). </td>
            </tr>
            <tr>
              <td
                style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                2.&nbsp;
              </td>
              <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                At 2 hours, other migraine headache characteristics, such as
                functional disability (P =.002), photophobia <br />(P =.02), and
                phonophobia (P =.08), were significantly improved after
                treatment with acetaminophen vs placebo.
              </td>
            </tr>
          </table>

        </div>
        <table style="height: 10px;"></table>
        <div class="col-lg-12 col-sm-12 col-md-12">
          <table style="border: 1px solid #124982;">
            <tr>
              <td style="padding:10px 10px;">
                <table>
                  <tr>
                    <td
                      style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #00A0DF;line-height: 16px;">
                      <strong>Conclusion</strong>
                    </td>
                  </tr>
                  <tr>
                    <td style="height: 4px;"></td>
                  </tr>
                  <tr>
                    <td style="font-family: OpenSansRegular;font-size: 12px;color: #00A0DF;line-height: 16px;">
                      <strong>Acetaminophen was highly effective for treating pain, functional disability, photophobia,
                        and
                        phonophobia
                        in a population-based sample of persons with migraine and was well tolerated.</strong>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>

        </div>

      </div>
    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      Lipton RB et al. Arch Intern Med 2000; 160: 3486-3492.
    </p>
  </div>
</ng-template>

<ng-template #Ali let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        Panadol Extra provides
        <strong>
          significantly more pain relief vs.
          standard Panadol in moderate-to-severe dysmenorrhea
          (period pain)
        </strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>
  <div class="modal-body" style="padding-top: 8px;">
    <div class="container" style="padding-left: 0px;">
      <div class="row">
        <div class="col-lg-6 col-md-6 colxl-6 col-sm-12">
          <table>
            <tr>
              <td style="vertical-align: top;">
                <table>
                  <tr>
                    <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                      Single-dose, placebo-controlled, double blind, three-way
                      crossover, outpatient study carried out in 320 women
                      with moderate-to-severe dysmenorrhea pain
                    </td>
                  </tr>
                  <tr>
                    <td style="height: 20px;">
                    </td>
                  </tr>
                  <tr>
                    <td style="font-family: OpenSansRegular;font-size: 14px;color: #124982;line-height: 16px;">
                      <strong>Results:</strong>
                    </td>
                  </tr>
                  <tr>
                    <td style="height: 10px;">
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <table>
                        <tr>
                          <td
                            style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                            •&nbsp;
                          </td>
                          <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                            Two tablets of Panadol Extra provides significantly more
                            pain relief than standard Panadol (p&#60;0.05), 130 mg caffeine or placebo (p&#60;0.01 for
                            both)
                          </td>
                        </tr>
                        <tr>
                          <td
                            style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                            •&nbsp;
                          </td>
                          <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                            Panadol Extra was also significantly more effective in
                            relieving abdominal cramping and backache
                          </td>
                        </tr>
                        <tr>
                          <td
                            style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                            •&nbsp;
                          </td>
                          <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                            No major treatment related adverse events were reported
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
        <div class="col-lg-6 col-md-6 colxl-6 col-sm-12">
          <table>
            <tr>
              <td style="vertical-align: top;">
                <table>
                  <tr>
                    <td style="font-family: OpenSansRegular;font-size: 11px;color: #124982;line-height: 16px;">
                      Significant pain relief with Panadol Extra lasts for up to 6 hours
                    </td>
                  </tr>
                  <tr>
                    <td style="height: 5px;"></td>
                  </tr>
                  <tr>
                    <td>
                      <table style="border:1px solid #124982">
                        <tr>
                          <td>
                            <img class="img-fluid" src="assets/images/panadol/significat6hr_ax.png">
                          </td>
                        </tr>
                      </table>
                    </td>

                  </tr>
                </table>
              </td>
            </tr>
          </table>
          <table style="height:20px"></table>


        </div>

      </div>
      <table>

        <tr>

          <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
            <strong>
              When taken at recommended doses, both paracetamol and the combination of paracetamol and
              caffeine are safe and effective treatments for
              primary dysmenorrhoea
            </strong>
          </td>
        </tr>
      </table>
      <table style="height: 20px;"></table>
    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      Ali Z et al. <i>Current Medical Research and Opinion</i>2007;23(4):841-851.<br />
      Single-dose Panadol Extra efficacy study A2370237
    </p>
  </div>
</ng-template>

<ng-template #A2370237 let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        Panadol Extra provides
        <strong>
          significantly more pain relief vs.
          standard Panadol in moderate-to-severe dysmenorrhea
          (period pain)
        </strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>
  <div class="modal-body" style="padding-top: 0px;">
    <div class="container" style="padding-left: 0px;">
      <div class="row">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12">

          <!-- <table style="height: 10px;"></table> -->
          <table>
            <tr>
              <td style="width: 40%;vertical-align: top;">
                <table>
                  <tr>
                    <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                      Single-dose, placebo-controlled, double blind, three-way
                      crossover, outpatient study carried out in 320 women
                      with moderate-to-severe dysmenorrhea pain
                    </td>
                  </tr>
                  <tr>
                    <td style="height: 20px;">

                    </td>
                  </tr>
                  <tr>
                    <td style="font-family: OpenSansRegular;font-size: 14px;color: #124982;line-height: 16px;">
                      <strong>Results:</strong>
                    </td>
                  </tr>
                  <tr>
                    <td style="height: 10px;">

                    </td>
                  </tr>
                  <tr>
                    <td>
                      <table>
                        <tr>
                          <td
                            style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                            •&nbsp;
                          </td>
                          <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                            Two tablets of Panadol Extra provides significantly more
                            pain relief than standard Panadol (p&#60;0.05), 130 mg caffeine or placebo (p&#60;0.01 for
                            both)
                          </td>
                        </tr>
                        <tr>
                          <td
                            style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                            •&nbsp;
                          </td>
                          <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                            Panadol Extra was also significantly more effective in
                            relieving abdominal cramping and backache
                          </td>
                        </tr>
                        <tr>
                          <td
                            style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                            •&nbsp;
                          </td>
                          <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                            No major treatment related adverse events were reported
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              </td>
              <td style="width: 60%; vertical-align: top;">
                <table>
                  <tr>
                    <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                      Significant pain relief with Panadol Extra lasts for up to 6 hours </td>
                  </tr>
                  <tr>
                    <td style="height: 5px;"></td>
                  </tr>
                  <tr>
                    <td>
                      <table style="border:1px solid #124982">
                        <tr>
                          <td>
                            <img class="img-fluid" src="assets/images/panadol/significat6hr.png">
                          </td>
                        </tr>
                      </table>
                    </td>

                  </tr>
                </table>
              </td>
            </tr>
          </table>
          <table style="height:20px"></table>
          <table>

            <tr>

              <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                <strong>When taken at recommended doses, both paracetamol and the combination of paracetamol and
                  caffeine are safe and effective treatments for
                  primary dysmenorrhoea</strong>
              </td>
            </tr>
          </table>
          <table style="height: 20px;"></table>

        </div>

      </div>
    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      Ali Z et al. <i>Current Medical Research and Opinion</i>2007;23(4):841-851.<br />
      Single-dose Panadol Extra efficacy study A2370237
    </p>
  </div>
</ng-template>

<ng-template #Milsom let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        Panadol for
        <strong>
          effective relief of period pain
        </strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div class="container" style="padding-left: 0px;">
      <div class="row">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12">
          <table>
            <tr>
              <td style="font-family: OpenSansRegular;font-size: 14px;color: #124982;line-height: 17px;">

                <strong>Two placebo-controlled studies examined acetaminophen (APAP) efficacy in dysmenorrhea<sup
                    style="line-height: 0px;">1</sup></strong>

              </td>
            </tr>
          </table>
          <table style="height: 10px;"></table>
          <table>
            <tr>
              <td
                style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;vertical-align: top;">

                1.&nbsp;

              </td>
              <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                Milsom, 2002 was a part of a pooled analysis, which compared APAP 1g with naproxen sodium 220 mg
                and placeb0 (PBO)
              </td>
            </tr>
            <tr>
              <td
                style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;vertical-align: top;">

                2.&nbsp;

              </td>
              <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                Randomised, double-blind, single dose, cross-over study in patients with primary dysmenorrhoea of
                moderate to severe intensity
              </td>
            </tr>
          </table>
          <table style="height: 20px;"></table>
          <table>
            <tr>

              <td style="font-family: OpenSansRegular;font-size: 14px;color: #124982;line-height: 17px;">
                <strong>For APAP, maximal pain relief was observed at 2 hrs post-dose. APAP showed
                  significant pain relief at 2, 3 and 4 hrs after administration versus PBO (p&#60;0.01)
                  and numerically superior pain relief at 5, 6 and 7 hrs after administration.</strong>
              </td>
            </tr>
          </table>
          <table style="height: 15px;"></table>
          <table>
            <tr>

              <td style="font-family: OpenSansRegular;font-size: 14px;color: #124982;line-height: 17px;">
                <strong>The second study (Pendergrass, 1985) demonstrated that APAP 650 mg was
                  superior to placebo in reducing menstrual pain.<sup
                    style="line-height: 0px;font-size: 10px;">2</sup></strong>
              </td>
            </tr>
          </table>
          <table style="height: 100px;"></table>
        </div>

      </div>
    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      1. Milsom I, Minic M, Dawood MY et al. Clinical Therapeutics 2002; 24(9): 1384-1400.<br />
      2. Pendergrass PB, Scott JN, Ream LJ, Agna MA. Gynecol Obstet Invest 1985; 19: 32-37.
    </p>
  </div>
</ng-template>

<ng-template #Wade let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        Panadol–effective in
        <strong>
          relieving musculoskeletal pain
        </strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>
  <div class="modal-body" style="padding-top: 0px;">
    <div class="container" style="padding-left: 0px;">
      <div class="row">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12">
          <table style="height: 12px;"></table>
          <div class="col-lg-4 col-md-4 col-sm-6"
            style="text-align: center;border-radius: 20px; background-color: #124982;padding: 7px;font-family: OpenSansRegular;font-size: 14px;color: #ffffff;line-height: 17px;">
            <strong>Wade et al.<sup style="line-height: 0px; font-size: 8px;">1</sup></strong>
          </div>
          <div class="col-lg-12 col-md-12 colxl-12 col-sm-12">
            <table style="height: 8px;"></table>
            <table>
              <tr>
                <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                  In a double-blind placebo- controlled study in patients with acute or chronic painful musculoskeletal
                  conditions, 1000 mg APAP was
                  statistically significantly superior to placebo on the three measures of pain (spontaneous, pain on
                  pressure, pain on movement) (p&#60;0.001).
                </td>
              </tr>
            </table>
            <table style="height: 12px;"></table>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-6"
            style="text-align: center;border-radius: 20px; background-color: #124982;padding: 7px;font-family: OpenSansRegular;font-size: 14px;color: #ffffff;line-height: 17px;">
            <strong>Hong et al.<sup style="line-height: 0px; font-size: 8px;">2</sup></strong>
          </div>
          <div class="col-lg-12 col-md-12 colxl-12 col-sm-12">
            <table style="height: 8px;"></table>
            <table>
              <tr>
                <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                  <strong>Acetaminophen has a Grade A recommendation for the treatment of acute and chronic low back
                    pain.</strong>
                </td>
              </tr>
              <tr>
                <td style="height: 5px;"></td>
              </tr>
              <tr>
                <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                  A total of 18 methods for the treatment of acute and chronic low-back pain were reviewed by the
                  assessment panel.
                </td>
              </tr>
              <tr>
                <td style="height: 5px;"></td>
              </tr>
              <tr>
                <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                  For acute low back pain, several randomized trials and higher-quality systematic reviews found
                  non-steroidal anti-inflammatory
                  drugs (NSAIDs), acetaminophen (APAP) superior for pain relief.
                </td>
              </tr>
            </table>
            <table style="height: 12px;"></table>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-6"
            style="text-align: center;border-radius: 20px; background-color: #124982;padding: 7px;font-family: OpenSansRegular;font-size: 14px;color: #ffffff;line-height: 17px;">
            <strong>Jones et al.<sup style="line-height: 0px; font-size: 8px;">3</sup></strong>
          </div>
          <table style="height: 8px;"></table>
          <table>
            <tr>
              <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 17px;">
                Meta-analysis included nine studies, involving 991 participants comparing NSAIDS with APAP.<br />
                Data tended to favour APAP; there was a lack of clinically important differences between the two groups
                in pain at less<br />
                than 24 hrs, days 1 to 3, or at day 7.<br />
                There was also no difference between swelling at either day 3 or day 7.<br />
                There was also little difference between the two groups in return to function at day 7.<br />
                There is no clinically important difference in analgesic efficacy between NSAIDs and other analgesics.
              </td>
            </tr>
          </table>
          <table style="height: 10px;"></table>
        </div>

      </div>
    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 12px;">
      1. Wade AG, Ward PJ. A double-blind comparison of meptazinol versus paracetamol and placebo in acute and chronic
      painful conditions presenting to the general practitioner. Curr Med Res and Opin 1982; 8(3): 191-197.<br />
      2. Hong JY, Song KS, Cho JH, Lee JH. An Updated Overview of Low Back Pain Management in Primary Care. Asian spine
      journal. 2017 Aug 1;11(4):653-60.<br />
      3. Jones P, Dalziel SR, Lamdin R, et al. Cochrane Database of Systematic Reviews 2015, Issue 7. Art. No.:
      CD007789. DOI: 10.1002/14651858.CD007789.pub2.<br />
    </p>
  </div>
</ng-template>

<ng-template #Towheed let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        Panadol tablets
        <strong>
          provide fast, effective pain relief against
          the joint pain associated with osteoarthritis
        </strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>
  <div class="modal-body" style="padding-top: 5px;">
    <div class="container" style="padding-left: 0px;">
      <div class="row">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12">
          <table style="height: 5px;"></table>
          <div class="col-lg-4 col-md-4 col-sm-6"
            style="text-align: center;border-radius: 20px; background-color: #124982;padding: 7px;font-family: OpenSansRegular;font-size: 12px;color: #ffffff;line-height: 17px;">
            <strong>
              Towheed, 2006: Cochrane Review.<sup style="line-height: 0px; font-size: 8px;">1</sup>
            </strong>
          </div>
          <div class="col-lg-12 col-md-12 colxl-12 col-sm-12">
            <table style="height: 5px;"></table>
            <table>
              <tr>
                <td
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 17px;padding-left: 25px;">
                  Acetaminophen was superior to placebo in five of the seven RCTs, and had a similar safety profile.
                </td>
              </tr>
            </table>
            <table style="height: 10px;"></table>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-6"
            style="text-align: center;border-radius: 20px; background-color: #124982;padding: 7px;font-family: OpenSansRegular;font-size: 12px;color: #ffffff;line-height: 17px;">
            <strong>
              Zhang, 2004<sup style="line-height: 0px; font-size: 8px;">2</sup>
            </strong>
          </div>
          <div class="col-lg-12 col-md-12 colxl-12 col-sm-12">
            <table style="height: 5px;"></table>
            <table>
              <tr>
                <td
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 17px;padding-left: 25px;">
                  In a meta-analysis of 10 RCTs including data from 1712 patients with symptomatic OA of the knee, hip
                  or
                  knee or multiple joints, APAP was effective in relieving OA pain (Effect Size = 0.21, 95% CI 0.02 to
                  0.41).
                </td>
              </tr>
            </table>
            <table style="height: 10px;"></table>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-6"
            style="text-align: center;border-radius: 20px; background-color: #124982;padding: 7px;font-family: OpenSansRegular;font-size: 12px;color: #ffffff;line-height: 17px;">
            <strong>
              Neame, 2004<sup style="line-height: 0px; font-size: 8px;">3</sup>
            </strong>
          </div>
          <table style="height: 5px;"></table>
          <table>
            <tr>
              <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 17px;padding-left: 25px;">
                In this updated meta-analysis of Zhang + 3 studies, the aggregated research data supported paracetamol
                as
                being more effective than placebo in relieving pain of large joint OA.
              </td>
            </tr>
          </table>
          <table style="height: 5px;"></table>
        </div>

      </div>
    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 12px;">
      1. Towheed T, Maxwell L, Judd M, Catton MThe Cochrane Library. 2006 Jan 1. Accessed October 2019.<br />
      2. Zhang W, Jones A, Doherty M. Ann Rheum Dis 2004; 63: 901-907.<br />
      3. Neame R, Zhang W, Doherty M. Ann Rheum Dis 2004; 63: 897-900.
    </p>
  </div>
</ng-template>

<ng-template #Bacon let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        Panadol (Extend/Osteo/Joint) as
        <strong>
          effective as Panadol<br />
          for relief of knee pain secondary to osteoarthritis
        </strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>
  <div class="modal-body" style="padding-top: 8px;">
    <div class="container" style="padding-left: 0px;">
      <div class="row">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12">
          <table style="height: 5px;"></table>
          <table>
            <tr>
              <td style="font-family: OpenSansBold; font-size: 12px;color: #124982;line-height: 16px;">
                Objectives:</td>
            </tr>
            <tr>
              <td
                style="font-family: OpenSansRegular; font-size: 12px;color: #124982;line-height: 16px;padding-left: 15px;">
                <strong>Primary:</strong> To compare the efficacy of sustained release Panadol versus standard Panadol
              </td>
            </tr>
            <!-- <tr>
              <td
                style="font-family: OpenSansRegular; font-size: 12px;color: #124982;line-height: 16px;padding-left: 15px;">
                <strong>Secondary:</strong> <br />
                &nbsp;&nbsp;&nbsp;1.&nbsp; Establish efficacy in other measurements of functional status (walking, pain
                during the day, sleep disturbance, morning stiffness)<br />
                &nbsp;&nbsp;&nbsp;2.&nbsp; Safety evaluation
              </td>
            </tr> -->
          </table>
          <table>
            <tr>
              <td
                style="font-family: OpenSansRegular;padding-left: 15px;font-weight: bold; font-size: 12px;color: #124982;line-height: 16px;">
                Secondary:</td>
            </tr>
          </table>
          <table>
            <tr>
              <td
                style="vertical-align: top;padding-left: 15px; font-family: OpenSansRegular; font-size: 12px;color: #124982;line-height: 16px;">
                1.</td>
              <td style="font-family: OpenSansRegular; font-size: 12px;color: #124982;line-height: 16px;">
                Establish efficacy in other measurements of functional status (walking, pain
                during the day, sleep disturbance, morning stiffness)</td>
            </tr>
            <tr>
              <td
                style="vertical-align: top;padding-left: 15px; font-family: OpenSansRegular; font-size: 12px;color: #124982;line-height: 16px;">
                2.</td>
              <td style="font-family: OpenSansRegular; font-size: 12px;color: #124982;line-height: 16px;">
                Safety evaluation</td>
            </tr>
          </table>
          <table style="height: 5px;"></table>
          <table>
            <tr>
              <td style="font-family: OpenSansBold; font-size: 12px;color: #124982;line-height: 16px;">
                Study design:</td>
            </tr>
          </table>
          <table>
            <tr>
              <td
                style="vertical-align: top;padding-left: 15px; font-family: OpenSansRegular; font-size: 12px;color: #124982;line-height: 16px;">
                1.</td>
              <td style="font-family: OpenSansRegular; font-size: 12px;color: #124982;line-height: 16px;">
                Multi-centre, double-blind, double-dummy, randomized, parallel group, therapeutic confirmatory study in
                403 patients with knee pain
                secondary to osteoarthritis</td>
            </tr>
            <tr>
              <td
                style="vertical-align: top;padding-left: 15px; font-family: OpenSansRegular; font-size: 12px;color: #124982;line-height: 16px;">
                2.</td>
              <td style="font-family: OpenSansRegular; font-size: 12px;color: #124982;line-height: 16px;">
                A non-inferiority study evaluating the efficacy and safety of sustained release Panadol
                (1.33 g, 3x daily) versus standard
                Panadol (1 g, 4x daily) in adults with OA of the knee</td>
            </tr>
          </table>
          <table style="height: 10px;"></table>
        </div>
        <div class="col-lg-6 col-md-6 colxl-6 col-sm-12">
          <table>
            <tr>
              <td>
                <table>
                  <tr>
                    <table style="border: 1px solid #000000;">
                      <tr>
                        <td style="height: 10px;"></td>
                      </tr>
                      <tr>
                        <td>
                          <img class="img-fluid" src="assets/images/panadol/panadolstandard_ax.png">
                        </td>
                      </tr>
                      <tr>
                        <td style="height: 10px;"></td>
                      </tr>
                    </table>
                  </tr>
                  <tr>
                    <td style="font-family: OpenSansRegular; font-size: 12px;color: #124982;line-height: 16px;">
                      Percentage of patients reporting a successful response* to patient global
                      assessment of pain relief on day 8
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
        <div class="col-lg-6 col-md-6 colxl-6 col-sm-12">
          <table>
            <tr>
              <td style="vertical-align: top;">
                <table>
                  <tr>
                    <td>
                      <table>
                        <tr>
                          <td style="vertical-align: top;">
                            <img class="img-fluid" src="assets/images/panadol/sustainedreleasetable_ax.png">
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12">
          <table>
            <tr>
              <td style="height: 10px;"></td>
            </tr>
            <tr>
              <td style="font-family: OpenSansRegular; font-size: 8px;color: #124982;line-height: 12px;">
                * A successful response was defined as moderate, good or very good patient assessment of global pain
                relief.
              </td>
            </tr>
            <tr>
              <td style="height: 10px;"></td>
            </tr>
            <tr>
              <td style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 12px;">
                Bacon TH, et al. <i>Br J Clin Pharmacol</i> 2002; 53(6):629-636.
              </td>
            </tr>
          </table>
        </div>
      </div>

    </div>
  </div>


</ng-template>


<ng-template #Benson let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        Panadol Osteo is more
        <strong>
          convenient for patients with knee OA
          which is associated with improved patient compliance
        </strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>
  <div class="modal-body" style="padding-top: 8px;">
    <div class="container" style="padding-left: 0px;">
      <div class="row">
        <!-- <div class="col-lg-12 col-md-12 colxl-12 col-sm-12">
          <table style="height: 5px;"></table>
          <table>
            <tr>
              <td style="font-family: OpenSansRegular;font-size: 14px;color: #124982;line-height: 18px;">
                <strong>Study design</strong>
              </td>
            </tr>
            <tr>
              <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                &nbsp;&nbsp;• Multicenter, open-label, crossover design in 210 patients aged 40-80 years with knee pain
                secondary to OA
              </td>
            </tr>
          </table>
          <table style="height: 20px;"></table>
        </div> -->
        <div class="col-lg-6 col-md-6 colxl-6 col-sm-12">
          <table>
            <tr>
              <td style="vertical-align: top;">
                <table>
                  <tr>
                    <td style="font-family: OpenSansRegular;font-size: 14px;color: #124982;line-height: 18px;">
                      <strong>Study design</strong>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <table>
                        <tr>
                          <td
                            style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                            •
                          </td>
                          <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                            Multicenter, open-label, crossover design in 210 patients aged 40-80 years with knee pain
                            secondary to OA
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td style="font-family: OpenSansRegular;font-size: 14px;color: #124982;line-height: 18px;">
                      <strong>Objectives</strong>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <table>
                        <tr>
                          <td
                            style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                            •
                          </td>
                          <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                            <strong>Primary:</strong> Proportion of subjects preferring Panadol Joint versus
                            standard paracetamol for the management of their OA
                          </td>
                        </tr>
                        <tr>
                          <td
                            style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                            •
                          </td>
                          <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                            <strong>Secondary:</strong> Various, including treatment regimen preference,
                            convenience and attitudes, Pain control, Safety evaluation
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td style="height: 20px;"></td>
                  </tr>
                  <tr>
                    <td style="font-family: OpenSansRegular;font-size: 14px;color: #124982;line-height: 18px;">
                      <strong>Significant pain relief for OA of the knee with
                        sustained-release Panadol</strong>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <img class="img-fluid" src="assets/images/panadol/Benson-table.png">
                    </td>
                  </tr>
                  <tr>
                    <td style="font-family: OpenSansRegular;font-size: 14px;color: #124982;line-height: 18px;">
                      <strong>Results:</strong>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <table>
                        <tr>
                          <td
                            style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                            •
                          </td>
                          <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                            Panadol Osteo is more convenient for patients with knee OA which is
                            associated with improved patient compliance.
                          </td>
                        </tr>
                        <tr>
                          <td
                            style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                            •
                          </td>
                          <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                            Improved compliance leads to better symptom control & less patients
                            are less likely to switch to less suitable medicines (e.g. NSAIDs)
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
        <div class="col-lg-6 col-md-6 colxl-6 col-sm-12">
          <table>

            <tr>
              <td style="font-family: OpenSansRegular;font-size: 14px;color: #124982;line-height: 18px;">
                <strong>Study medications</strong>
              </td>
            </tr>
            <tr>
              <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                Panadol Joint (665 mg x 2) three times daily <br />for 14 days<br />
                Standard Panadol (500 mg x 2) four times daily <br />for 14 days
              </td>
            </tr>
            <tr>
              <td style="height: 10px;"></td>
            </tr>
            <tr>
              <td>
                <table>
                  <tr>
                    <td>
                      <img class="img-fluid" src="assets/images/panadol/benson.JPG" />

                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>

        </div>
        <table style="height: 10px;"></table>

      </div>

    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      Benson M et al. <i>J Int Med Res</i> 2009;37:1321-1335
    </p>
  </div>
</ng-template>

<ng-template #Bradley let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        Panadol is as
        <strong>
          effective as prescription-strength ibuprofen<br /> in
          reducing chronic knee pain due to osteoarthritis
        </strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>
  <div class="modal-body" style="padding-top: 0px;">
    <div class="container" style="padding-left: 0px;">
      <div class="row">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12">
          <table style="height: 5px;"></table>
          <table>
            <tr>
              <td
                style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                •
              </td>
              <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                Randomised, double-blind study of Panadol 4000 mg/day versus ibuprofen 1200 mg/day or 2400 mg/day
                in patients with chronic knee pain due to osteoarthritis (OA) (N=184).
              </td>
            </tr>
          </table>
          <table style="height: 5px;"></table>
        </div>
        <div class="col-lg-6 col-md-6 colxl-6 col-sm-12">
          <table>
            <tr>
              <td style="vertical-align: top;">
                <table>
                  <tr>
                    <td>
                      <table>
                        <tr>
                          <td
                            style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                            •
                          </td>
                          <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                            Patients completed expanded versions of the
                            Stanford Health Assessment Questionnaire
                            (HAQ) disability and pain scales.
                          </td>
                        </tr>
                        <tr>
                          <td style="height: 5px;"></td>
                        </tr>
                        <tr>
                          <td
                            style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                            •
                          </td>
                          <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                            Panadol was as effective as
                            prescription-strength
                            ibuprofen in reducing pain
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
        <div class="col-lg-6 col-md-6 colxl-6 col-sm-12">
          <table>
            <tr>
              <td>
                <table style="border: 1px solid #00A0DF;">
                  <tr>
                    <td style="padding: 10px;">
                      <img class="img-fluid" src="assets/images/panadol/efficacyeleder_ax_2x.png" />
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>

        <table style="height: 10px;"></table>



      </div>
    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      Bradley et al. New Engl J Med1991;325:87–91.
    </p>
  </div>
</ng-template>

<ng-template #Yelland let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        Panadol (Extend/Osteo/Joint)<br />
        <strong>

          as effective as celecoxib in many patients with OA
        </strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>
  <div class="modal-body" style="padding-top: 8px;">
    <div class="container" style="padding-left: 0px;">
      <div class="row">
        <div class="col-lg-6 col-md-6 colxl-6 col-sm-12">
          <!-- <table style="height: 10px;"></table>
          <table style="height: 20px;"></table> -->
          <table>
            <tr>
              <td style="vertical-align: top;">
                <table>
                  <tr>
                    <td>
                      <table>
                        <tr>
                          <td
                            style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                            •
                          </td>
                          <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                            Evaluation of community-based patients with OA in
                            multiple sites undergoing n-of-1 studies (N=59)
                          </td>
                        </tr>
                        <tr>
                          <td style="height: 20px;"></td>
                        </tr>
                        <tr>
                          <td
                            style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                            •
                          </td>
                          <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                            Double-blind, crossover comparison of
                            sustained-release Panadol 1330 mg 3 times/day with
                            celecoxib 200 or 400 mg/day
                          </td>
                        </tr>
                        <tr>
                          <td style="height: 20px;"></td>
                        </tr>
                        <tr>
                          <td
                            style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                            •
                          </td>
                          <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                            5 primary outcomes were given equal weight: pain
                            and stiffness, functional limitation, medication preference,
                            changes in drug use, and adverse effects
                          </td>
                        </tr>
                        <tr>
                          <td style="height: 20px;"></td>
                        </tr>

                      </table>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
        <div class="col-lg-6 col-md-6 colxl-6 col-sm-12">

          <table>
            <tr>
              <td>
                <img class="img-fluid" src="assets/images/panadol/pop17_ax.png" />
              </td>
            </tr>
          </table>


          <table style="height: 10px;"></table>

        </div>
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12">
          <table>
            <tr>
              <td
                style="vertical-align: top; font-family: OpenSansRegular;font-size: 16px;color: #124982;line-height: 15px;">

              </td>
              <td style="font-family: OpenSansRegular;font-size: 16px;color: #124982;line-height: 19px;">
                <strong>Sustained-release Panadol was as
                  effective as celecoxib in 80% of
                  patients with OA</strong>
              </td>
            </tr>
          </table>

        </div>


      </div>
    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      Yelland MJ <i>et al. Rheumatology</i> 2007;46:135–140.
    </p>
  </div>
</ng-template>

<ng-template #A1030174 let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        Panadol Actifast shows more rapid onset of<br />
        <strong>
          analgesia versus placebo after third molar extraction
        </strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>
  <div class="modal-body" style="padding-top: 8px;">
    <div class="container" style="padding-left: 0px;">
      <div class="row">
        <div class="col-lg-6 col-md-6 colxl-6 col-sm-12">
          <table style="height: 5px;"></table>
          <table>
            <tr>
              <td style="vertical-align: top;">
                <table>
                  <tr>
                    <td
                      style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px; padding-bottom: 16px;">
                      Phase IV, randomized, double-blind, placebo-controlled,
                      parallel group study in 156 subjects to evaluate time to
                      onset of analgesia following administration of Panadol
                      Actifast versus Panadol and placebo after third
                      molar extraction
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px; padding-bottom: 15px;">
                      <strong>Results</strong>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <table>

                        <tr>
                          <td
                            style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                            •
                          </td>
                          <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                            <div>
                              Panadol Actifast showed significantly greater improvement in
                              pain intensity and pain relief variables than placebo in all
                              efficacy analyses (p&#60;0.05)
                              <table>
                                <tr>
                                  <td style="height: 5px;"></td>
                                </tr>

                                <tr>
                                  <td
                                    style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                                    -
                                  </td>
                                  <td
                                    style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                                    Using the diary card method, a faster onset of analgesia
                                    (at 20 minutes post-dose) was observed for Panadol Actifast
                                    compared to placebo (p&#60;0.05)
                                  </td>
                                </tr>
                              </table>
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td style="height: 5px;"></td>
                        </tr>
                        <tr>
                          <td
                            style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                            •
                          </td>
                          <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                            For Panadol, onset of analgesia compared to placebo was
                            observed 30 minutes post-dose (p&#60;0.05)
                          </td>
                        </tr>
                        <tr>
                          <td style="height: 5px;"></td>
                        </tr>
                        <tr>
                          <td
                            style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                            •
                          </td>
                          <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                            AUC over the first 35 minutes post-dose was significantly
                            greater for Panadol Actifast compared to Panadol (p&#60;0.05) </td>
                        </tr>
                        <tr>
                          <td style="height: 5px;"></td>
                        </tr>
                        <tr>
                          <td
                            style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                            •
                          </td>
                          <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 12px;">
                            Both Panadol Actifast and Panadol were well tolerated
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
        <div class="col-lg-6 col-md-6 colxl-6 col-sm-12">
          <table>
            <tr>
              <td>
                <table style="border: 1px solid #124982;">
                  <tr>
                    <td style="padding: 10px;">
                      <img class="img-fluid" src="assets/images/panadol/Absorption-rando.png" />
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
        <table style="height: 10px;"></table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      GSK Study A1030174 Clinical Study Report
    </p>
  </div>
</ng-template>

<ng-template #A1030231 let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        Panadol –
        <strong>
          fast effective relief from dental pain
        </strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>
  <div class="modal-body" style="padding-top: 0px;">
    <div class="container" style="padding-left: 0px;">
      <div class="row">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12">
          <table style="height: 10px;"></table>
          <div class="col-lg-4 col-md-4 col-sm-6"
            style="text-align: center;border-radius: 20px; background-color: #124982;padding: 7px;font-family: OpenSansRegular;font-size: 12px;color: #ffffff;line-height: 17px;font-weight:bold">
            <strong>
              PK/PD Dental Pain Study<sup style="line-height: 0px; font-size: 8px;">1,2</sup>
            </strong>
          </div>
          <div class="col-lg-12 col-md-12 colxl-12 col-sm-12">
            <table style="height: 10px;"></table>
            <table>
              <tr>
                <td>
                  <table>
                    <tr>
                      <td
                        style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 13px;padding-left: 25px;">
                        •
                      </td>
                      <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 13px;">
                        The dental pain study demonstrated that the median time to onset of perceptible pain relief for
                        Panadol Tablets
                        was 24.7 minutes and was significantly better than placebo (P&#60;0.001). </td>
                    </tr>
                    <tr>
                      <td style="height: 5px;"></td>
                    </tr>
                    <tr>
                      <td
                        style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 13px;padding-left: 25px;">
                        •
                      </td>
                      <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 13px;">
                        Panadol tablets vs placebo showed significant median difference in pain relief score for Panadol
                        tablets vs placebo
                        at each time point starting at 30 minutes through 240 minutes (p&#60;0.05). </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
            <table style="height: 15px;"></table>
          </div>

          <div class="col-lg-4 col-md-4 col-sm-6"
            style="text-align: center;border-radius: 20px; background-color: #124982;padding: 7px;font-family: OpenSansRegular;font-size: 12px;color: #ffffff;line-height: 17px;font-weight:bold">
            <strong>
              Deshpande 2014<sup style="line-height: 0px; font-size: 8px;">3</sup>
            </strong>
          </div>
          <div class="col-lg-12 col-md-12 colxl-12 col-sm-12">
            <table style="height: 8px;"></table>
            <table>
              <tr>
                <td
                  style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 13px;padding-left: 25px;">
                  •
                </td>
                <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 13px;">
                  In this double-blind, active-controlled (IBU, 400 mg TID) study (N=30), patients we were able to
                  achieve clinically
                  effective pain relief with APAP 500 mg TID.
                </td>
              </tr>
              <tr>
                <td style="height: 5px;"></td>
              </tr>
              <tr>
                <td
                  style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 13px;padding-left: 25px;">
                  •
                </td>
                <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 13px;">
                  APAP was taken for 3 consecutive days; the mean visual analog scale (VAS) scores (± standard
                  deviation) were Day 1 = 1.20 ± 0.6, Day 2 = 0.70 ± 0.59 and Day 3 = 0.36 ± 0.49.
                </td>
              </tr>
            </table>
          </div>
          <table style="height: 15px;"></table>
        </div>

      </div>
    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 12px;">
      1. GSK STUDY A1030231<br />
      2. Grattan TJ et al. PK/PD investigation of a novel paracetamol tablet containing sodium bicarbonate. J Clin
      Pharmacol 2004; 44 (10):1188.<br />
      3. Deshpande A, Bhargava D, Gupta M. Ann Maxillofac Surg. 2014 Jul- Dec;4(2):176-7
    </p>
  </div>
</ng-template>

<ng-template #Burnett let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        Panadol Actifast provides rapid pain relief in<br />
        <strong>
          patients with acute sore throat
        </strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>
  <div class="modal-body" style="padding-top: 10px;">
    <div class="container" style="padding-left: 0px;">
      <div class="row">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12">
          <table style="height: 0px;"></table>
          <table>
            <tr>
              <td style="font-family: OpenSansRegular;font-size: 16px;color: #124982;line-height: 15px;">
                <strong>Starts to relieve pain in just 15 min</strong>
              </td>
            </tr>
          </table>
        </div>
        <table style="height: 10px;"></table>
        <div class="col-lg-6 col-md-6 colxl-6 col-sm-12">
          <table>
            <tr>
              <td style="vertical-align: top;">
                <table>
                  <tr>
                    <td>
                      <table>
                        <tr>
                          <td
                            style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                            •
                          </td>
                          <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                            A randomised (3:1) double-blind, placebo-controlled
                            study in 241 adult patients with acute sore throat.
                          </td>
                        </tr>
                        <tr>
                          <td style="height: 5px;"></td>
                        </tr>
                        <tr>
                          <td
                            style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                            •
                          </td>
                          <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                            For the onset of analgesia from the mean Sore Throat
                            Relief Scale, within 15 minutes of dosing Panadol
                            Actifast provided significantly more pain relief than
                            placebo (p&#8804;0.03), an effect that continued for all time
                            points up to 6 hours post-dosing (p&#60;0.05 for all).
                          </td>
                        </tr>
                        <tr>
                          <td style="height: 5px;"></td>
                        </tr>
                        <tr>
                          <td
                            style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                            •
                          </td>
                          <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                            Onset of analgesia for Sore Throat Relief Scale
                            score >1 was significantly faster for Panadol Actifast
                            versus placebo (p=0.02), and was achieved by
                            significantly within 15 minutes post-dose by
                            significantly more patients receiving Panadol
                            Actifast than placebo (p&#60;0.04).
                          </td>
                        </tr>
                        <tr>
                          <td style="height: 5px;"></td>
                        </tr>
                        <tr>
                          <td
                            style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                            •
                          </td>
                          <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                            Onset of analgesia following Panadol Actifast was
                            reported by 49% of patients within 15 minutes,
                            and 88% within 30 minutes.
                          </td>
                        </tr>
                        <tr>
                          <td style="height: 5px;"></td>
                        </tr>

                      </table>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
        <div class="col-lg-6 col-md-9 col-sm-12">
          <table style="border: 1px solid #124982;">
            <tr>
              <td>
                <img class="img-fluid" src="assets/images/panadol/Burnett-2006.png" />
              </td>
            </tr>
          </table>
          <table>
            <tr>
              <td style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
                *p&#8804;0.03 versus placebo<br />
                STRS, sore throat relief scale (0, no relief; 1, slight relief; 2, mild relief; 3, moderate
                relief;<br />
                4, considerable relief; 5, almost complete relief; 6, complete relief)<br />
                Single-dose Panadol Actifast study A1030232
              </td>
            </tr>
          </table>
          <table style="height: 10px;"></table>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      Burnett I<i>et al. Clinical Therapeutics</i>2006;28(9):1273-1278.
    </p>
  </div>
</ng-template>

<ng-template #Aoki let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        Paracetamol is suitable for management of
        <strong>
          pain and fever after vaccination
        </strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>
  <div class="modal-body" style="padding-top: 8px;">
    <div class="container" style="padding-left: 0px;">
      <div class="row">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12">
          <table>
            <tr>
              <td style="vertical-align: top; padding-top: -2px;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 5px;">
                  Prospective, randomized, double-blind placebo-controlled trial evaluated the effects of acetaminophen
                  on the
                  incidence of adverse effects to, and the immunogenicity of, whole-virus influenza vaccine in health
                  care workers.
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top; padding-top: -2px;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 5px;">
                  A dose of 0.5 ml of inactivated trivalent whole-virus influenza vaccine was injected into the deltoid
                  muscle.
                  Volunteers were randomly assigned to ingest two capsules of acetaminophen in a half dose
                  (162.5 mg per capsule) or a full dose (325 mg per capsule) or two identical placebo capsules. Capsules
                  were
                  to be taken at vaccination and at 4, 8 and 12 hours afterward.
                </p>
              </td>
            </tr>
            <tr>
              <td style="vertical-align: top; padding-top: -2px;">
                <p style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                  •&nbsp;
                </p>
              </td>
              <td>
                <p
                  style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;margin-bottom: 5px;">
                  Compared with the placebo group the incidence of sore arm was 25% to 28% lower in the half-dose and
                  full-dose
                  groups respectively at 24 hours after vaccination, and the rate of nausea was 90% lower in the
                  full-dose group.
                </p>
              </td>
            </tr>
          </table>
          <table style="height: 20px;"></table>

        </div>
        <div class="col-lg-12 col-md-12 col-xl-12 col-sm-12">
          <table style="border: 1px solid #00A0DF;">
            <tr>
              <td style="vertical-align: top; padding: 10px 15px">
                <table>
                  <tr>
                    <td
                      style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #00A0DF;line-height: 16px;">
                      •
                    </td>
                    <td
                      style="font-family: OpenSansRegular;font-size: 12px;color: #00A0DF;line-height: 16px;margin-bottom: 5px;">
                      The full dose of acetaminophen significantly reduced the incidence of sore arm
                      and nausea without affecting the antibody response.
                    </td>
                  </tr>
                  <tr>
                    <td style="height: 10px;"></td>
                  </tr>
                  <tr>
                    <td
                      style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #00A0DF;line-height: 16px;">
                      •
                    </td>
                    <td style="font-family: OpenSansRegular;font-size: 12px;color: #00A0DF;line-height: 16px;">
                      Acetaminophen use may increase the acceptance of influenza vaccine by health care
                      workers in whom concern about side effects is an impediment to vaccination.
                    </td>
                  </tr>

                </table>

              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      Aoki FY et al. Can Med Assoc J 1993; 149 (10): 1425-1430.
    </p>
  </div>
</ng-template>

<ng-template #A1900385 let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        <strong>
          Panadol Advance is more rapidly absorbed vs.
          Standard Paracetamol in
        </strong>patients with type 2 diabetes
        with gastric dysmotility
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>

  <div class="modal-body" style="padding-top: 8px;">
    <div class="container" style="padding-left: 0px;">
      <div class="row">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12">
          <table>
            <tr>
              <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                A single centre, open label, randomised, two way crossover, PK study (n = 21) to compare the
                AUC<sub>0-30min</sub> for Panadol Advance tablets and
                Panadol base tablets in patients with gastric dysmotility in a semi-fed state. Patients with type 2
                diabetes was chosen as a dysmotility model.
              </td>
            </tr>
          </table>
          <table style="height: 10px;"></table>
          <table>
            <tr>
              <td style="font-family: OpenSansRegular;font-size: 16px;color: #124982;line-height: 15px;">
                <strong>Results</strong>
              </td>
            </tr>
          </table>
          <table style="height: 20px;"></table>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12">
              <table>
                <tr>
                  <td
                    style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                    •
                  </td>
                  <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                    Panadol Advance was more rapidly absorbed than Panadol
                    Base tablets.
                  </td>
                </tr>
                <tr>
                  <td style="height: 5px;"></td>
                </tr>
                <tr>
                  <td
                    style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                    •
                  </td>
                  <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                    AUC<sub>0-30min</sub> (primary objective) was statistically
                    significantly greater for Panadol Advance than Panadol
                    Base (P = 0.0004).
                  </td>
                </tr>
                <tr>
                  <td style="height: 5px;"></td>
                </tr>
                <tr>
                  <td
                    style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                    •
                  </td>
                  <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                    AUC<sub>0-60min</sub> and Cplasma at 30 minutes were statistically
                    significantly greater (P = 0.0014) and higher (P = 0.0002),
                    respectively, for Panadol Advance compared to Panadol Base.
                  </td>
                </tr>
                <tr>
                  <td style="height: 5px;"></td>
                </tr>
                <tr>
                  <td
                    style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                    •
                  </td>
                  <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                    T<sub>max</sub> was shorter for Panadol Advance compared to Panadol
                    Base (p=0.1448, NS).
                  </td>
                </tr>
                <tr>
                  <td style="height: 5px;"></td>
                </tr>
                <tr>
                  <td
                    style="vertical-align: top; font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                    •
                  </td>
                  <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                    Overall the tested population (diabetics) in this study showed
                    slower absorption of paracetamol (acetaminophen) from both
                    treatments when compared with results observed in healthy
                    volunteers. This could be attributed in part to the gastric
                    enteropathy that is known to occur in diabetes mellitus.
                  </td>
                </tr>
                <tr>
                  <td style="height: 5px;"></td>
                </tr>
              </table>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
              <table>
                <tr>
                  <td>
                    <table style="border: 1px solid #124982;">
                      <tr>
                        <td style="padding: 10px;">
                          <img class="img-fluid" src="assets/images/panadol/dysmotility_ax.png" />
                        </td>
                      </tr>
                    </table>
                    <table style="height: 10px;"></table>
                  </td>
                </tr>
                <tr>
                  <td style="font-family: OpenSansRegular;font-size: 9.5px;color: #124982;line-height: 11px;">
                    Mean plasma concentration vs. time profiles for Panadol Advance and
                    Panadol Base
                  </td>
                </tr>
              </table>
            </div>
            <table style="height: 10px;"></table>

          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      GSK Data on File. Study A1900385.
    </p>
  </div>
</ng-template>
<ng-template #A1900260 let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        <strong>
          Panadol Advance tablets disintegrate
        </strong><br />faster than standard Panadol
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>

  <div class="modal-body" style="padding-top: 8px;">
    <div class="container" style="padding-left: 0px;">
      <div class="row">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12">
          <table>
            <tr>
              <td
                style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;vertical-align: top;">
                •
              </td>
              <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                A pivotal, Phase I, randomized, single-centre, open-label, single dose, two-way crossover study in 40
                healthy subjects
              </td>
            </tr>
            <tr>
              <td
                style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;vertical-align: top;">
                •
              </td>
              <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                The plasma pharmacokinetic profile of paracetamol (acetaminophen) following administration of Panadol
                Advance tablets and standard
                Panadol tablets in the fasted state were compared
              </td>
            </tr>
            <tr>
              <td
                style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;vertical-align: top;">
                •
              </td>
              <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                1 g dose (2 tablets) of FD or standard Panadol tablets administered after an overnight fast
              </td>
            </tr>
            <tr>
              <td
                style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;vertical-align: top;">
                •
              </td>
              <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                Blood samples taken through 10 h post-dose
              </td>
            </tr>
          </table>
          <table style="height: 20px;"></table>
          <table>
            <tr>
              <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">

                Scintigraphic assessment of Panadol Advance</td>
            </tr>
          </table>
          <table style="height: 15px;"></table>
          <table>
            <tr>
              <td style="font-family: OpenSansRegular;font-size: 14px;color: #124982;line-height: 17px;">
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12" style="text-align:right">
                    <div>
                      <table>
                        <tr>
                          <td
                            style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;text-align: left;padding-bottom: 8px;">
                            Panadol Advance tablets disintegrate<br /> significantly faster than Panadol
                          </td>
                        </tr>
                      </table>
                    </div>
                    <div><img class="img-fluid" src="assets/images/panadol/pop13-2ax.png"></div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-12">
                    <div>
                      <table>
                        <tr>
                          <td
                            style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;text-align: left;padding-bottom: 8px;">
                            Panadol Advance completely disintegrates<br /> 5x faster than Panadol
                          </td>
                        </tr>
                      </table>
                    </div>
                    <div><img class="img-fluid" src="assets/images/panadol/pop13-2x.png" style="height: 174px;"></div>
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      Study A1900260, Wilson CG et al. Drug Dev Ind Pharm 2011;37:747-753.
    </p>
  </div>
</ng-template>


<ng-template #A4000684 let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        <strong>
          Significantly faster relief with 1000 mg Panadol Advance<br />
          vs 500 mg
        </strong>Panadol following third molar extraction
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div class="container" style="padding-left: 0px;">
      <div class="row">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12">
          <table>
            <tr>
              <td
                style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;vertical-align: top;">
                •&nbsp;&nbsp;
              </td>
              <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                A single center, single-dose, randomized, placebo-controlled, double-blind, parallel group.
              </td>
            </tr>
            <tr>
              <td
                style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;vertical-align: top;">
                •&nbsp;&nbsp;
              </td>
              <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                300 subjects with moderate or severe pain following 3rd molar extraction.
              </td>
            </tr>
          </table>
          <table style="height: 20px;"></table>
        </div>
        <div class="col-lg-6 col-md-6 colxl-6 col-sm-12">
          <table>
            <tr>
              <td style="font-family: OpenSansRegular;font-size: 15px;color: #124982;line-height: 15px;">
                <strong>Endpoints</strong>
              </td>
            </tr>
          </table>
          <table>
            <tr>
              <td
                style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;vertical-align: top;">
                •&nbsp;&nbsp;
              </td>
              <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                Pain ratings: SPRID, TOTPAR, SPID and PRS.
              </td>
            </tr>
            <tr>
              <td
                style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;vertical-align: top;">
                •&nbsp;&nbsp;
              </td>
              <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                Stopwatch method: time to first perceptible relief, time to
                meaningful relief, time to first perceptible further confirmed
                by meaningful relief.
              </td>
            </tr>
            <tr>
              <td
                style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;vertical-align: top;">
                •&nbsp;&nbsp;
              </td>
              <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                Time to rescue analgesics.
              </td>
            </tr>
          </table>
          <table>
            <tr>
              <td style="font-family: OpenSansRegular;font-size: 15px;color: #124982;line-height: 15px;padding-top: 10px;">
                <strong>Results:</strong>
              </td>
            </tr>
          </table>
          <table>
            <tr>
              <td
                style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;vertical-align: top;">
                •&nbsp;&nbsp;
              </td>
              <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                At 6 hours post-dose, the FD Panadol 1 g group reported
                significantly superior pain efficacy versus the FD Panadol
                500 mg group (P=0.0004) as measured by SPRID 6h.
              </td>
            </tr>
            <tr>
              <td
                style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;vertical-align: top;">
                •&nbsp;&nbsp;
              </td>
              <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                FD Panadol 500 mg was superior to placebo at 0-2hr
                and 0-4hr, but was just short of significance at 0-6hr
                (although secondary efficacy endpoints showed significance
                through 6 hours).
              </td>
            </tr>
            <tr>
              <td
                style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;vertical-align: top;">
                •&nbsp;&nbsp;
              </td>
              <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                The 1 g FD Panadol group also saw superior pain relief at 2 and
                4 hours post-dose versus the FD Panadol 500 mg group.
              </td>
            </tr>
            <tr>
              <td
                style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;vertical-align: top;">
                •&nbsp;&nbsp;
              </td>
              <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                On the efficacy outcome of time to relief, the FD Panadol 1 g
                group reported a median time to first perceptible relief of
                15 minutes (as confirmed by meaningful relief), which was
                significantly faster (P&#60;0.05) than the FD Panadol 500 mg or
                the placebo groups.
              </td>
            </tr>
          </table>
        </div>
        <div class="col-lg-6 col-md-6 colxl-6 col-sm-12">
          <div>
            <img class="img-fluid" src="assets/images/panadol/popimg.svg">
          </div>
          <div>
            <table>
              <tr>
                <td
                  style="font-family: OpenSansRegular;font-size: 10px;color: #124982;line-height: 14px;padding: 10px 0px;">
                  Panadol 1000 mg is more effective than Panadol 500 mg *(P
                  <0.001);<br />
                  Both are significantly more effective than placebo; <sup>+</sup>(P<0.01) </td> </tr> <tr>
                <td style="font-family: OpenSansRegular;font-size: 10px;color: #124982;line-height: 14px;">
                  SPRID = sum of pain reduction and intensity differences over the<br /> 6-hour evaluation period,
                  TOTPAR = Total Pain Relief, SPID =Sum of Pain Intensity Difference, PRS = Pain Relief Scoress
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      GSK. Data on file. Dose-Response Efficacy Study A4000684.
    </p>
  </div>
</ng-template>

<ng-template #wilson let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        <strong>
          Increased early exposure with
        </strong>Panadol Advance versus standard Panadol
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>

  <div class="modal-body" style="padding-top: 8px;">
    <div class="container" style="padding-left: 0px;">
      <div class="row">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12">
          <table>
            <tr>
              <td
                style="font-family: OpenSansBold; font-size: 16px;color: #124982;line-height: 15px;margin-bottom: 10px;">
                Panadol Advance<sup style="line-height: 0px;">®</sup> (paracetamol 500mg + Optizorb technology)
              </td>
            </tr>
          </table>
          <table style="height: 10px;"></table>
        </div>
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12">
          <table>
            <tr>
              <td
                style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;vertical-align: top;">
                •&nbsp;&nbsp;
              </td>
              <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                is absorbed more rapidly in the fasted state and can be detected in the serum after 10 minutes<sup
                  style="line-height: 0px;">1</sup>
              </td>
            </tr>
            <tr>
              <td style="height: 5px;"></td>
            </tr>
            <tr>
              <td
                style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;vertical-align: top;">
                •&nbsp;&nbsp;
              </td>
              <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                is absorbed more rapidly than Panadol<sup style="line-height: 0px;">2</sup>
              </td>
            </tr>
          </table>
          <table style="height: 15px;"></table>
        </div>
        <div class="col-lg-12 col-md-7 colxl-6 col-sm-12">
          <table>
            <tr>
              <td
                style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;padding-bottom: 10px;">
                Plasma concentrations of paracetamol in a PK study of
                Panadol Advance® vs standard paracetamol tablets (1000 mg)<sup style="line-height: 0px;">2</sup>
              </td>
            </tr>
          </table>
        </div>
        <div class="col-lg-12 col-md-6 colxl-6 col-sm-12" style="display: flex;justify-content: center;">
          <table style="border: 1px solid #124982; padding: 10px;">
            <tr>
              <td>
                <img class="img-fluid" src="assets/images/panadol/Advanceversus_ax.png"
                  style="width: 445px;height: 215px;">
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      1. Wilson CG <i>et al. Drug Dev Ind Pharm</i> 2011;37:747-753.<br />
      2. Study A03001V96.
    </p>
  </div>
</ng-template>

<ng-template #Yue let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        Significant pain relief with<br /><strong>
          Panadol Advance following post-surgical dental pain
        </strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>

  <div class="modal-body">
    <div class="container" style="padding-left: 0px;">
      <div class="row">
        <div class="col-lg-12 col-md-12 colxl-12 col-sm-12">
          <table>
            <tr>
              <td
                style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;vertical-align: top;">
                •&nbsp;&nbsp;
              </td>
              <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                For SPRID, from 0 to 6 hrs, fast-dissolving APAP tablet (FD-APAP) 1000 mg had a significantly
                greater effect than placebo in both Study I and Study II (P &#60; 0.0001).
              </td>
            </tr>
            <tr>
              <td style="height: 5px;"></td>
            </tr>
            <tr>
              <td
                style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;vertical-align: top;">
                •&nbsp;&nbsp;
              </td>
              <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                FD-APAP 1000 mg had also a greater effect than both lower doses of active treatments; that is,
                FD-APAP 500 mg <br />(P =0.0004) and APAP 650 mg (P &#60; 0.0009).
              </td>
            </tr>
            <tr>
              <td
                style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;vertical-align: top;">
                •&nbsp;&nbsp;
              </td>
              <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 15px;">
                APAP 650 mg demonstrated efficacy over placebo (P = 0.0001), whereas the 500-mg dose of FD-APAP
                failed to demonstrate a significant effect over placebo (P = 0.1307) for the 0 to 6 hrs post dose period
              </td>
            </tr>
          </table>
          <table style="height: 20px;"></table>
        </div>

      </div>
    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      GSK STUDY A4000685<br />
      Yue Y, Collaku A, Brown J, Buchanan WL, Reed K, Cooper SA, Otto J.. Clinical therapeutics. 2013 Sep
      30;35(9):1306-20.
    </p>
  </div>
</ng-template>

<ng-template #Moller let-modal>
  <div class="row pad-l-r-30">
    <div class="modal-header header-p-t-b">
      <p class="modal-title" style="font-family: OpenSansRegular;color: #124982;font-size: 25px;line-height: 36px;"
        id="GhoshTitle">
        Panadol Actifast provides <strong>
          rapid relief from dental pain
        </strong>
      </p>
    </div>
    <div class="closeBtn">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true"><img src="assets/images/close.png"></span>
      </button>
    </div>
  </div>

  <div class="modal-body">
    <div class="container" style="padding-left: 0px;">
      <div class="row">
        <div class="col-lg-6 col-md-6 colxl-6 col-sm-12">
          <table>
            <tr>
              <td style="font-family: OpenSansRegular;font-size: 16px;color: #124982;line-height: 15px;">
                <strong>Twice as fast as Panadol Base</strong>
              </td>
            </tr>
            <tr>
              <td style="height: 10px;"></td>
            </tr>
            <tr>
              <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                A randomized, double-blind, placebo-controlled
                study compared the time to onset of analgesia and
                the analgesic efficacy of two formulations of
                paracetamol (acetaminophen) 1000 mg: Panadol
                Actifast and Panadol Base - in 242 patients with
                moderate or severe pain following dental surgery
              </td>
            </tr>
          </table>
          <table>
            <tr>
              <td style="height: 20px;"></td>
            </tr>
          </table>

          <table>
            <tr>
              <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                <strong>Results</strong>
              </td>
            </tr>
          </table>
          <table>
            <tr>
              <td style="height: 10px;"></td>
            </tr>
          </table>
          <table>
            <tr>
              <td
                style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;vertical-align: top;">
                •&nbsp;&nbsp;
              </td>
              <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                Median time to onset of analgesia was shorter with
                Panadol Actifast compared to Panadol<br />
                (20 vs 45 minutes, respectively).
              </td>
            </tr>
            <tr>
              <td
                style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;vertical-align: top;">
                •&nbsp;&nbsp;
              </td>
              <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                During the first 45 minutes after administration,
                Panadol Actifast was more effective at each scheduled
                assessment time than Panadol Base.
              </td>
            </tr>
            <tr>
              <td
                style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;vertical-align: top;">
                •&nbsp;&nbsp;
              </td>
              <td style="font-family: OpenSansRegular;font-size: 12px;color: #124982;line-height: 16px;">
                Median time to meaningful pain relief was shorter with
                Panadol Actifast (45 minutes) compared to Panadol Base
                (45 vs 60 minutes, respectively).
              </td>
            </tr>
          </table>
        </div>
        <div class="col-lg-6 col-md-6 colxl-6 col-sm-12">
          <table style="border: 1px solid #124982; padding: 10px;">
            <tr>
              <td>
                <img class="img-fluid" src="assets/images/panadol/mollerp.png">
              </td>
            </tr>
          </table>
          <table>
            <tr>
              <td style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 12px; padding-top: 5px;">
                This graph shows time-effect curve for the average pain relief from categorical verbal rating scale
                after
                administration of Panadol Actifast, Panadol Base and placebo (similar in appearance to Panadol Actifast
                or Panadol Base).<br />
                p&#60;0.001 for both (+)Panadol Actifast vs. placebo and (#) Panadol Base vs. placebo.<br />
                *p&#60;0.05 and **p&#60;0.001 vs. Panadol Base<br />
                §p&#60;0.05 vs. Panadol Actifast
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <p style="font-family: OpenSansRegular;font-size: 8px;color: #124982;line-height: 11px;">
      Moller P et al. <i>J Clin Pharmacol</i> 2000;40:370–378.
    </p>
  </div>
</ng-template>
